import { NextApiResponse } from 'next'
import { signOut } from 'next-auth/react'

import { apiSignOutLocal } from '@/api'
import { IS_SERVER, log, ROUTE_SIGN_IN } from '@/lib'

export const redirectToSignInPage = (res?: NextApiResponse, callbackUrl?: string) => {
  log.debug('redirectToSignInPage:: called')
  const url = !IS_SERVER && callbackUrl ? `${ROUTE_SIGN_IN}?callbackUrl=${callbackUrl}` : ROUTE_SIGN_IN
  return IS_SERVER && res ? res?.redirect(url) : signOut({ callbackUrl: url })
}

export const signOutUser = async () => {
  try {
    const result = await apiSignOutLocal()
    signOut()
    log.debug('signOutUser:: user signed out')
    return result
  } catch (error) {
    log.debug('signOutUser:: error: ', error)
    throw error
  }
}
